<template>
    <div>
        <b-tab no-body :title="$t('message.infoPatient')" id="tab1">
            <b-card-body>
                <div>
                    <b-row>
                        <b-col sm="12">
                            <h3 class="text-center">{{ $tc('message.patients',1) }}</h3>
                        </b-col>
                        <b-col class="mb-3">
                            

                            <p>
                                {{ $t('message.name') }}:
                                <span class="font-weight-bold">{{ nom }}</span>
                            </p>

                            <p>
                                {{ $t('message.fileNumber') }}:
                                <span class="font-weight-bold">{{ getMedicalValue('numero_dossier')}}</span>
                            </p>

                            <p>
                                {{ $t('message.email') }}:
                                <span class="font-weight-bold">{{getUserValue('email')}}</span>
                            </p>
                            <p>
                                {{ $t('message.consentement') }}:
                                <button class="border-0 text-info ml-1 bg-white" @click="UpdateConsentementPatient"><i class="fa fa-edit"></i>Modifier</button>
                                <button v-if="this.signer" class="border-0 text-success ml-2 bg-white" @click="viewConsentementPatient"><i class="fa fa-print"></i>Télécharger</button>
                            </p>
                        </b-col>
                        <b-col  class="mb-3">
                            <p>
                                {{ $tc('message.cities',2) }}:
                                <span class="font-weight-bold">{{ ville }}</span>
                            </p>
                            <p>
                                {{ $t('message.number') }}:
                                <span class="font-weight-bold">{{ telephone }}</span>
                            </p>
                        </b-col>
                        
                        <b-col col sm="12">
                            <h3 class="text-center">{{ $tc('message.medecinReferent',1) }}</h3>
                                    <div>
                                    <b-row class="mt-1">
                                        <b-col md="9" sm="6" v-if="hasAdminRole || hasMedecinControleRole || hasAssistante">
                                            <b-form-group
                                                    id="responsable-group"
                                                    label-for="responsable">
                                                <!-- Options -->
                                                 <multiselect v-model="$v.form.responsable.$model" :options="mDoctors" :multiple="true" :placeholder="$tc('message.medecinReferent', 1)" selectLabel="Sélectionner" label="nom" track-by="id"></multiselect>
                                              
                                                <b-form-invalid-feedback v-if="errorshasField('responsable')">
                                                    {{ getErrorsField('responsable') }}
                                                </b-form-invalid-feedback>

                                            </b-form-group>
                                            
                                        </b-col>
                                        <b-col md="3" sm="6" v-if="hasAdminRole || hasMedecinControleRole || hasAssistante">
                                            <b-link class="ml-2" @click="onAddReferent" variant="primary">
                                                <i class="fas fa-plus-circle edit-icon"></i> {{ $tc('message.add', 1) }}
                                            </b-link> 
                                        </b-col> 
                                    </b-row>
                            </div>
                            <template v-if="mReferentDoctors.length > 0">
                                <div v-for="item in mReferentDoctors" :key="item.id">
                                <hr />
                                <div class="row">
                                    <div class="col col-md-4">
                                        {{ $t('message.medecin') }}
                                        <p class="font-weight-bold">{{ item.nom }}</p>
                                    </div>

                                    <div class="col col-md-2">
                                        {{ $t('message.phone') }}
                                        <p class="font-weight-bold">{{ item.phone }}</p>
                                    </div>

                                    <div class="col col-md-4">
                                        {{ $t('message.email') }}
                                        <p class="font-weight-bold">{{ item.email }}</p>
                                    </div>
                                    <div class="col col-md-2">
                                        {{ $t('message.action') }}
                                        <b-link class="ml-4" style="color:red" @click="removeReferent(item)" variant="primary" v-if="hasAdminRole || hasMedecinControleRole || hasAssistante">
                                                <i class="fas fa-delete edit-icon" style="color:red"></i> {{ $tc('message.delete', 1) }}
                                        </b-link> 
                                    </div>
                                </div>
                                </div>
                            </template>
                            <template v-else>
                                <div>
                                    <h3>
                                        {{ $tc('message.nodoctor', 1) }}
                                    </h3>
                                </div>
                            </template>
                            <hr />
                        </b-col>
                    </b-row>
                </div>
                <div>
                    <b-row>
                        <b-col sm="6" v-if="hasAdminRole || hasMedecinControleRole || hasAssistante || hasSouscripteurRole || hasPatientRole">
                            <!-- <hr> -->

                            <h3 class="">{{ $tc('message.subscribers',1) }}</h3>

                            <p>
                                {{ $t('message.name') }}:
                                <span class="font-weight-bold"> {{getSouscripteurValue('nom').toUpperCase()}} {{ getSouscripteurValue('prenom').charAt(0).toUpperCase() + getSouscripteurValue('prenom').substring(1)}}</span>
                            </p>

                            <p>
                                {{ $t('message.email') }}:
                                <span class="font-weight-bold">{{getSouscripteurValue('email')}}</span>
                            </p>

                            <p>
                                {{ $t('message.number') }}:
                                <span class="font-weight-bold">{{getSouscripteurValue('telephone')}}</span>
                            </p>
                        </b-col>
                        <b-col sm="6"  class="mb-3">
                            <h3 class="">{{ $tc('message.contactPersonne') }}</h3>
                            <p>
                                {{ $tc('message.firstName',2) }}:
                                <span class="font-weight-bold" v-if="info">{{ info.contact_firstName }}</span>
                            </p>
                            <p>
                                {{ $tc('message.lastName',2) }}:
                                <span class="font-weight-bold" v-if="info">{{ info.contact_name }}</span>
                            </p>
                            <p>
                                {{ $t('message.number') }}:
                                <span class="font-weight-bold" v-if="info">{{ info.contact_phone }}</span>
                            </p>
                        </b-col>
                    </b-row>
                </div>
                <hr>
                <div>
                    <b-row>
                        <b-col col sm="12" v-if="hasAdminRole ||  hasPraticienRole || hasMedecinControleRole || hasAssistante">
                            <b-dropdown id="dropdown-left" :text="$tc('message.addConsultation')" variant="link" class="m-2" no-caret v-if="hasAdminRole ||  hasPraticienRole || hasMedecinControleRole || hasAssistante">
                                <b-dropdown-item :to="{ name: 'add-consultation-manuscrit' , params: { file: this.file_id } }">{{$t('message.manuscrit')}}</b-dropdown-item>
                                <b-dropdown-item v-if="isFemale" :to="{ name: 'add-consultation-obstetric', params: { file: this.file_id } }">{{$t('message.obstetric')}}</b-dropdown-item>
                                <b-dropdown-item :to="{ name: 'add-consultation-general' , params: { file: this.file_id } }">{{$t('message.general')}}</b-dropdown-item>
                                <b-dropdown-item :to="{ name: 'add-consultation-cardiology' , params: { file: this.file_id } }">{{$t('message.cardiology')}}</b-dropdown-item>
                                <b-dropdown-item href="#">{{$t('message.dermatology')}}</b-dropdown-item>
                                <b-dropdown-item href="#">{{$t('message.endocrinology')}}</b-dropdown-item>
                                <b-dropdown-item href="#">{{$t('message.gastroenterology')}}</b-dropdown-item>
                                <b-dropdown-item href="#">{{$t('message.geriatrics')}}</b-dropdown-item>
                                <b-dropdown-item href="#">{{$t('message.hématologie')}}</b-dropdown-item>
                                <b-dropdown-item href="#">{{$t('message.nephrology')}}</b-dropdown-item>
                                <b-dropdown-item href="#">{{$t('message.neurology')}}</b-dropdown-item>
                                <b-dropdown-item href="#">{{$t('message.ophthalmology')}}</b-dropdown-item>
                                <b-dropdown-item href="#">{{$t('message.oncology')}}</b-dropdown-item>
                                <b-dropdown-item href="#">{{$t('message.earNoseThroat')}}</b-dropdown-item>
                                <b-dropdown-item href="#">{{$t('message.pediatrics')}}</b-dropdown-item>
                                <b-dropdown-item href="#">{{$t('message.pneumology')}}</b-dropdown-item>
                                <b-dropdown-item href="#">{{$t('message.psychiatry')}}</b-dropdown-item>
                                <b-dropdown-item href="#">{{$t('message.rheumatology')}}</b-dropdown-item>
                                <b-dropdown-item href="#">{{$t('message.stomatology')}}</b-dropdown-item>
                                <b-dropdown-item :to="{ name: 'add-tele-consultation' , params: { file: this.file_id } }">{{$t('message.tele')}}</b-dropdown-item>
                            </b-dropdown>

                            <b-link variant="primary" @click="toAllergie">
                                <i class="fas fa-plus-circle edit-icon"></i> {{ $tc('message.allergies', 1) }}
                            </b-link>
                            <!--                                                <br>-->
                            <b-link class="ml-4" variant="primary" @click="toAntecedent">
                                <i class="fas fa-plus-circle edit-icon"></i> {{ $tc('message.antecedents', 1) }}
                            </b-link>
                            <!--                                                <br>-->
                            <!--                                                <b-link class="ml-4" :to="{ name: 'add-consultation-obstetric', params: { file: this.file_id } }" variant="primary" v-if="isFemale">-->
                            <!--                                                    <i class="fas fa-plus-circle edit-icon"></i> {{ $tc('message.obstetricConsultations', 1) }}-->
                            <!--                                                </b-link>-->
                            <!--                                                <b-link class="ml-4" :to="{ name: 'add-consultation-general' , params: { file: this.file_id } }" variant="primary">-->
                            <!--                                                    <i class="fas fa-plus-circle edit-icon"></i> {{ $tc('message.generalConsultations', 1) }}-->
                            <!--                                                </b-link>-->
                            <!--                                                <b-link class="ml-4" :to="{ name: 'add-consultation-cardiology', params: { file: this.file_id } }" variant="primary">-->
                            <!--                                                    <i class="fas fa-plus-circle edit-icon"></i> {{ $t('message.cardiologyConsultations') }}-->
                            <!--                                                </b-link>-->
                            <!--                                                <br>-->
                            <b-link class="ml-4" :to="{ name: 'add-treatments', params: { file: this.file_id } }" variant="primary">
                                <i class="fas fa-plus-circle edit-icon"></i> {{ $t('message.currentTreatments') }}
                            </b-link>
                            <b-link class="mr-2" :to="{ name: 'add-lab-result' , params: { file: this.file_id }}" variant="primary">
                                <i class="fas fa-plus-circle edit-icon"></i> {{ $tc('message.labResults',2) }}
                            </b-link>
                            <!--                                                <br>-->
                            <b-link class="ml-4 mr-2" :to="{ name: 'add-imagery-result' , params: { file: this.file_id }}" variant="primary">
                                <i class="fas fa-plus-circle edit-icon"></i> {{ $tc('message.imageryResults',2) }}
                            </b-link>
                            <!--                                                <br>-->
                            <b-link class="ml-5" :to="{ name: 'add-hospitalisation', params: { file: this.file_id } }" variant="primary">
                                <i class="fas fa-plus-circle edit-icon"></i> {{ $tc('message.hospitalisations',2) }}
                            </b-link>

                        </b-col>
                    </b-row>
                </div>
            </b-card-body>
        </b-tab>
        <b-modal id="consentement" size="md" centered title="Signature du consentement éclairé" :hide-footer="true">
           <div class="row">
            <div class="col-md-12">
                <p>Consulter le <a style="color: #2dcecc;" target="_blank" href="https://www.medicasure.com/particuliers/consentement-eclaire">Consentement éclairé</a> et cocher les cases ci-dessous</p>
            </div>
            <div class="col-md-12 mb-2">
                <div class="custom-control custom-checkbox">
                    <input type="checkbox" class="custom-control-input" value="1" v-model="form.consentement" id="consentement_eclaire" name="consentement">
                    <label class="custom-control-label" for="consentement_eclaire">Je valide le consentement éclairé</label>
                </div>
            </div>
            <div class="col-md-12 mb-2">
                <div class="custom-control custom-checkbox">
                    <input type="checkbox" class="custom-control-input" value="0" v-model="form.restriction" id="restriction" name="restriction">
                    <label class="custom-control-label" for="restriction">Restriction des informations sensibles au souscripteur</label>
                </div>
            </div>
            <div class="col-md-12 border w-100 h-100" v-if="hasPatientRole && form.consentement">
                <img :src="dataUrl" class="img-fluid" v-if="dataUrl!= null && !disabled">
                <vueSignature v-else ref="signature" :sigOption="option" :w="'450px'" :h="'300px'"></vueSignature> 
            </div>
           </div>
           <div class="col-md-12 text-center">
                <button @click="save" class="btn btn-primary">Enregistrer</button>
                <button @click="clear" class="btn btn-secondary" v-if="hasPatientRole">Modifier</button>
                <button @click="undo" class="btn btn-danger" v-if="hasPatientRole">Arrière</button>
           </div>
            <template #modal-footer>
               
            </template>
        </b-modal>
    </div>
</template>
<script>
import { mapGetters } from 'vuex';
import _ from 'lodash';
import $ from 'jquery';
import SlimSelect from "slim-select";
import axios from 'axios';
import Vue from 'vue';
import AppConfig from "../../constants/AppConfig";
import moment from "moment";
import vueSignature from "vue-signature";
import Multiselect from 'vue-multiselect'
export default {
    name: "PersonnalData",
    components:{
        vueSignature,
        Multiselect
    },
    computed: {
         ...mapGetters(["file", "controlDoctors"
        ]),
        mMedicalFile: function () {
            return _.isUndefined(this.file) ? [] : this.file;
        },
        isFemale: function () {
            return this.mMedicalFile.hasOwnProperty('patient') ? this.mMedicalFile.patient.sexe == "F" : false;
        },
        signer: function () {
            return this.file.patient.consentement == 1 ? true : false
        },
        can: function () {
            return this.hasAdminRole || this.hasGestionnaireRole || this.hasPraticienRole || this.hasMedecinControleRole || this.hasAssistante;
        },
        mReferentDoctors:{
            get: function () {
                let dArray = [];
                if (!_.isUndefined(this.mMedicalFile.patient)) {
                    if (!_.isUndefined(this.mMedicalFile.patient.medecin_referent)) {
                    _.forEach(this.mMedicalFile.patient.medecin_referent, function(doctor) {
                        let d = {};
                            if (!_.isNull(doctor.medecin_controles)){
                                if((typeof doctor.medecin_controles.user == 'object') && (!_.isNull(doctor.medecin_controles)) &&(!_.isNull(doctor.medecin_controles.user))){
                                let prenom = doctor.medecin_controles.user.prenom != null || doctor.medecin_controles.user.prenom != undefined ?  doctor.medecin_controles.user.prenom : "";
                                prenom =  prenom.toLowerCase();
                                d.nom =  (doctor.medecin_controles.user.nom).toUpperCase() + " "+ prenom.charAt(0).toUpperCase() + prenom.substring(1);
                                d.id = doctor.medecin_controles.user.id;
                                d.phone = doctor.medecin_controles.user.telephone
                                d.email = doctor.medecin_controles.user.email
                                if (d.nom.length >0){
                                    dArray.push(d);
                                }
                            }
                        }
                    });
                    }
                }
                return dArray;
            },
            set: function(newValue){
                this.mReferentDoctors = newValue;
            }
        },
        nom: function () {
            if (!_.isUndefined(this.mMedicalFile.patient)) {
                if (!_.isUndefined(this.mMedicalFile.patient.user)) {
                    let prenom = (this.mMedicalFile.patient.user.prenom == null) ? '' : this.mMedicalFile.patient.user.prenom;
                    return (this.mMedicalFile.patient.user.nom).toUpperCase() + " " + prenom.charAt(0).toUpperCase() + prenom.substring(1);
                }
                return "";
            }
            return '';
        },
        ville: function () {
            if (!_.isUndefined(this.mMedicalFile.patient)) {
                if (!_.isUndefined(this.mMedicalFile.patient.user)) {
                    // console.log(this.mMedicalFile.patient.user);
                    // let prenom = (this.mMedicalFile.patient.user.prenom == null) ? '' : this.mMedicalFile.patient.user.prenom;
                    return this.mMedicalFile.patient.user.ville;
                }
                return "";
            }
            return '';
        },
        info: function (){
            if (this.mMedicalFile.affiliation.length > 0) {
                // console.log(this.mMedicalFile.affiliation.length > 0)
                let rArray = {};

            _.forEach(_.orderBy(this.mMedicalFile.affiliation,['created_at'],['desc']), function(affiliation) {
                let a = {};
                // if((affiliation == 'object') && (!_.isNull(affiliation))){
                    a.contact_firstName = affiliation.contact_firstName;
                    a.contact_name = affiliation.contact_name;
                    a.contact_phone = affiliation.contact_phone;
                    rArray = JSON.stringify(a);
                // }
                // console.log(rArray);
            });
            // console.log(JSON.parse(rArray));
            return JSON.parse(rArray);
            }
        },
        telephone: function () {
            if (!_.isUndefined(this.mMedicalFile.patient)) {
                if (!_.isUndefined(this.mMedicalFile.patient.user)) {
                    // console.log(this.mMedicalFile.patient.user);
                    // let prenom = (this.mMedicalFile.patient.user.prenom == null) ? '' : this.mMedicalFile.patient.user.prenom;
                    return this.mMedicalFile.patient.user.telephone;
                }
                return "";
            }
            return '';
        },
        mDoctors: function() {
            let dArray = [];

            _.forEach(_.orderBy(this.controlDoctors,['created_at'],['desc']), function(doctor) {
                let d = {};
                if((typeof doctor.user == 'object') && (!_.isNull(doctor.user))){
                    let prenom = doctor.user.prenom != null ?  doctor.user.prenom : "";
                    prenom =  prenom.toLowerCase();
                    d.nom =  (doctor.user.nom).toUpperCase() + " "+ prenom.charAt(0).toUpperCase() + prenom.substring(1);
                    d.id = doctor.user.id;

                    if (d.nom.length >0){
                        dArray.push(d);
                    }
                }

            });
            return dArray;
        },
    },
    props: ['hasAdminRole', 'hasMedecinControleRole', 'hasAssistante', 'hasSouscripteurRole', 'hasPatientRole', 'hasPraticienRole', 'file_id'],
    data() {
        return {
            option:{
                penColor:"rgb(0, 0, 0)",
                backgroundColor:"rgb(255,255,255)"
            },
            disabled: JSON.parse(localStorage.getItem('user'))['signature'] == null ? true : false,
            dataUrl: JSON.parse(localStorage.getItem('user'))['signature'],
          	form:{
              responsable: [],
              consentement: 1,
              restriction: 0
            },
            referentDoctors: [],
            filtered: [{
                    id: 1,
                    text: 'Tous'
                },
                {
                    id: 2,
                    text: 'Non Archivés'
                },
                {
                    id: 3,
                    text: 'Non Transmis'
                },
                {
                    id: 4,
                    text: 'Archivés'
                },
                {
                    id: 5,
                    text: 'Transmis'
                },
            ],
            show:false,
            filteredValue: "",
            prescriptionsColumns: [{
                label: this.$i18n.t('message.prescriptionDate'),
                field: 'date_prescription',
                type: 'date',
                dateInputFormat: 'yyyy-MM-dd HH:mm:ss',
                dateOutputFormat: 'dd/MM/yyyy',
            }, ],
            allergiesColumns: [{
                    label: 'Description',
                    field: 'description',
                },
                // {
                //     label: this.$i18n.t('message.startDate'),
                //     field: 'date',
                //     type: 'date',
                //     dateInputFormat: 'yyyy-MM-dd',
                //     dateOutputFormat: 'dd/MM/yyyy',
                // },
            ],

            labResultsColumns: [{
                    label: 'Description',
                    field: 'description',
                },
                {
                    label: this.$i18n.t('message.date'),
                    field: 'date',
                    type: 'date',
                    dateInputFormat: 'yyyy-MM-dd',
                    dateOutputFormat: 'dd/MM/yyyy',
                },
            ],

            imgResultsColumns: [{
                    label: 'Description',
                    field: 'description',
                },
                {
                    label: this.$i18n.t('message.date'),
                    field: 'date',
                    type: 'date',
                    dateInputFormat: 'yyyy-MM-dd',
                    dateOutputFormat: 'dd/MM/yyyy',
                },
            ],

            antecedentsColumns: [{
                    label: this.$i18n.tc('message.types', 1),
                    field: 'type',
                },
                {
                    label: 'Description',
                    field: 'description',
                    html: true,
                },
                {
                    label: this.$i18n.t('message.startDate'),
                    field: 'date',
                    type: 'date',
                    dateInputFormat: 'yyyy-MM-dd',
                    dateOutputFormat: 'dd/MM/yyyy',
                },
            ],

            manuscritColumns: [{
                    label: this.$i18n.tc('message.institutions', 1),
                    field: 'etablissement',
                },
                {
                    label: this.$i18n.tc('message.practitioners', 1),
                    field: 'praticien',
                },
                {
                    label: this.$i18n.tc('message.types', 1),
                    field: 'type',
                },
                {
                    label: this.$i18n.t('message.consultationDate'),
                    field: 'date',
                    type: 'date',
                    dateInputFormat: 'yyyy-MM-dd',
                    dateOutputFormat: 'dd/MM/yyyy',
                },
            ],

            comptesRenduOpColumns: [{
                    label: this.$i18n.tc('message.institutions', 1),
                    field: 'etablissement',
                },
                // {
                //   label: this.$i18n.tc('message.practitioners',1),
                //   field: 'praticien',
                // },
                {
                    label: this.$i18n.t('message.typeIntervention'),
                    field: 'type',
                },
                {
                    label: this.$i18n.t('message.dateIntervention'),
                    field: 'date',
                    type: 'date',
                    dateInputFormat: 'yyyy-MM-dd HH:mm',
                    dateOutputFormat: 'dd/MM/yyyy HH:mm',
                },
            ],

            medecinesColumns: [{
                    label: this.$i18n.tc('message.institutions', 1),
                    field: 'etablissement',
                },
                {
                    label: this.$i18n.tc('message.practitioners', 1),
                    field: 'consultant',
                },

                {
                    label: this.$i18n.t('message.consultationDate'),
                    field: 'date',
                    type: 'date',
                    dateInputFormat: 'yyyy-MM-dd',
                    dateOutputFormat: 'dd/MM/yyyy',
                },
                {
                    label: this.$i18n.tc('message.reasons', 1),
                    field: 'motifs',
                },

                {
                    label: this.$i18n.t('message.conclusion'),
                    field: 'conclusions',
                    html: true
                },
                {
                    label: this.$i18n.t('message.suggestTreatment'),
                    field: 'traitement',
                    html: true
                },
            ],
            cardiologiesColumns: [{
                    label: this.$i18n.tc('message.institutions', 1),
                    field: 'etablissement',
                },
                {
                    label: this.$i18n.tc('message.practitioners', 1),
                    field: 'consultant',
                },
                {
                    label: this.$i18n.t('message.consultationDate'),
                    field: 'date',
                    type: 'date',
                    dateInputFormat: 'yyyy-MM-dd',
                    dateOutputFormat: 'dd/MM/yyyy',
                },
                {
                    label: this.$i18n.tc('message.reasons', 1),
                    field: 'motifs',
                },

                {
                    label: this.$i18n.t('message.conclusion'),
                    field: 'conclusions',
                    html: true
                },
            ],
            kinesitherapiesColumns: [{
                    label: this.$i18n.tc('message.institutions', 1),
                    field: 'etablissement',
                },
                {
                    label: this.$i18n.tc('message.practitioners', 1),
                    field: 'consultant',
                },
                {
                    label: this.$i18n.t('message.consultationDate'),
                    field: 'date',
                    type: 'date',
                    dateInputFormat: 'yyyy-MM-dd',
                    dateOutputFormat: 'dd/MM/yyyy',
                },
                {
                    label: this.$i18n.tc('message.reasons', 1),
                    field: 'motifs',
                },

                {
                    label: this.$i18n.t('message.conclusion'),
                    field: 'conclusions',
                    html: true
                },
            ],
            hospitalisationsColumns: [{
                    label: this.$i18n.tc('message.reasons', 1),
                    field: 'motifs',
                },
                {
                    label: this.$i18n.tc('message.practitioners', 1),
                    field: 'consultant',
                },
                {
                    label: this.$i18n.t('message.entryDate'),
                    field: 'date_entree',
                    type: 'date',
                    dateInputFormat: 'yyyy-MM-dd',
                    dateOutputFormat: 'dd/MM/yyyy',
                },

                {
                    label: this.$i18n.t('message.exitDate'),
                    field: 'date_sortie',
                    type: 'date',
                    dateInputFormat: 'yyyy-MM-dd',
                    dateOutputFormat: 'dd/MM/yyyy',
                },

                {
                    label: this.$i18n.t('message.exitTreatment'),
                    field: 'traitement',
                    html: true
                },
            ],

            obstetricsColumns: [{
                    label: this.$i18n.tc('message.institutions', 1),
                    field: 'etablissement',
                },
                {
                    label: this.$i18n.tc('message.practitioners', 1),
                    field: 'consultant',
                },
                {
                    label: this.$i18n.t('message.pregnancyNumber'),
                    field: 'numero',
                    type: 'number',
                },
                {
                    label: this.$i18n.t('message.ddr'),
                    field: 'date',
                    type: 'date',
                    dateInputFormat: 'yyyy-MM-dd',
                    dateOutputFormat: 'dd/MM/yyyy',
                },
                {
                    label: this.$i18n.t('message.serology'),
                    field: 'serologie',
                },
                {
                    label: this.$i18n.t('message.bloodGroup'),
                    field: 'groupe',
                },
            ],

            traitementsColumns: [{
                    label: 'Description',
                    field: 'description',
                },
                // {
                //     label: this.$i18n.t('message.prescriptionDate'),
                //     field: 'date',
                //     type: 'date',
                //     dateInputFormat: 'yyyy-MM-dd HH:mm:ss',
                //     dateOutputFormat: 'dd/MM/yyyy',
                // },
            ],

            echograhiesColumns: [{
                    label: this.$i18n.tc('message.types', 2),
                    field: 'type',
                },
                {
                    label: this.$i18n.t('message.ddr'),
                    field: 'ddr',
                    type: 'date',
                    dateInputFormat: 'yyyy-MM-dd',
                    dateOutputFormat: 'dd/MM/yyyy',
                },
                {
                    label: this.$i18n.t('message.dpa'),
                    field: 'dpa',
                    type: 'date',
                    dateInputFormat: 'yyyy-MM-dd',
                    dateOutputFormat: 'dd/MM/yyyy',
                },
                {
                    label: this.$i18n.t('message.amenorrheaWeek'),
                    field: 'semaine_amenorrhee',
                },

            ],

            paginationOptions: {
                enabled: true,
                mode: 'records',
                perPageDropdown: [3, 6, 10]
            },

            enabled: {
                enabled: true
            },

            sort: {
                enabled: true,
                initialSortBy: {
                    field: 'date',
                    type: 'desc'
                }
            },
            
        }
    },
    validations() {
        return {
            form: {
                responsable:{},
            }
        }
	},
    methods: {
        errorshasField(field) {
            return this.errors ? this.errors.hasOwnProperty(field) : false;
        },
        bilanFinancier (){
        axios.get(AppConfig.apiUrl+`/bilans/financiers/${this.dossier_medical_slug}`, {headers: {'Authorization': "Bearer " + localStorage.getItem('ms-token')}}).then(res => {
            window.open(res.data.link, "_blank"); 
        }).catch(error => {
            console.log('error ', error);
        })
        },
        displayNumber(value) {
            return Number(value).toLocaleString("fr") + " XAF";
        },
        removeReferent(item){
            let self = this;
            let args = {
                slug: item.id+'|'+this.mMedicalFile.patient_id
            };

            let successMessage = this.$i18n.t('supprimé');
            let errorMessages = {
                generic: this.$i18n.t('message.genericError'),
                error: this.$i18n.t('message.error')
            };
            //this.mReferentDoctors = this.mReferentDoctors;
            this.$store.dispatch('deleteMedecinPatient', {
                args,
                successMessage,
                errorMessages
            }).then(() => {
            self.$bvModal.hide('delete-modal');               
             this.getMedicalFile();
            });
        },
        toAntecedent() {
            this.$router.push({
                name: 'add-antecedent',
                params: {
                    file: this.file_id
                }
            })
        },
        getMedicalValue(item) {
            return this.mMedicalFile.hasOwnProperty(item) ? this.mMedicalFile[item] : "";
        },

        getUserValue(item) {
            if (this.mMedicalFile.hasOwnProperty('patient')) {
                if (this.mMedicalFile.patient.hasOwnProperty('user')) {
                    return this.mMedicalFile.patient.user[item];
                }
                return "";
            }
            return "";
        },

        getSouscripteurValue(item) {
            if (this.mMedicalFile.hasOwnProperty('patient')) {
                if (this.mMedicalFile.patient.hasOwnProperty('souscripteur')) {
                    if (!_.isNull(this.mMedicalFile.patient.souscripteur)) {
                        return this.mMedicalFile.patient.souscripteur.user[item] !== null ? this.mMedicalFile.patient.souscripteur.user[item]:"";
                    }
                }
                return "";
            }
            return "";
        },
        checkIfProfileComplete(){
            let user = JSON.parse(localStorage.getItem('user'));
                if(this.dataUrl == null){
                    this.$bvModal.show('consentement');
                }
        }, 
        toAllergie() {
            this.$router.push({
                name: 'add-allergy',
                params: {
                    file: this.file_id
                }
            })
        },    
        save(){
            const formData = new FormData();
            if(this.dataUrl == null && this.hasPatientRole){
                var _this = this;
                const signature = _this.$refs.signature.save();
                formData.append('signature', signature)
            }
            formData.append('consentement', this.form.consentement ? 1 : 0)
            formData.append('restriction', this.form.restriction ? 1 : 0)
            formData.append('id', this.mMedicalFile.patient.user_id)

            axios.post(`${AppConfig.apiUrl}/signature/user`, formData, {
                headers: {
                    'content-type': 'multipart/form-data',
                    'Authorization': "Bearer " + localStorage.getItem('ms-token')
                }
            }).then(res => {
                this.$bvModal.hide('consentement');
                if(this.dataUrl == null){
                    Vue.swal("Votre consentement a été ajouté avec succès", '', 'success');
                }else{
                    Vue.swal("Votre consentement a été mis à jour avec succès", '', 'success');
                }
                if(this.hasPatientRole){
                    let user = JSON.parse(localStorage.getItem('user'));
                    user = {...user, signature: res.data.signature};
                    localStorage.setItem("user", JSON.stringify(user));
                }
                this.disabled = false;
                this.dataUrl = res.data.signature;
            }).catch(error => {
                console.log('error ', error);
            })

        },
        clear(){
            var _this = this;
            this.disabled = true;
            _this.$refs.signature.clear();
        },
        undo(){
            var _this = this;
            _this.$refs.signature.undo();
        },
        viewConsentementPatient(){
            axios.get(AppConfig.apiUrl+`/consentement/${this.mMedicalFile.patient.souscripteur.slug}/${this.mMedicalFile.patient.slug}`, {headers: {'Authorization': "Bearer " + localStorage.getItem('ms-token')}}).then(res => {
                window.open(res.data, '_blank').focus();
            });
        },
        UpdateConsentementPatient(){
            this.$bvModal.show('consentement');
        },
        displayDate(date) {
            return moment(date).format("dddd, MMMM Do YYYY, h:mm:ss a");
        },
        getListOfMedicalAdvices() {
            if (!this.hasPatientRole && !this.hasSouscripteurRole && this.can) {
                this.$store.dispatch('getMedicalAdvices', {
                    args: {}
                });
            }
        },
        getDoctors() {
          let args = {
            offset: this.offset,
            limit: this.limit
          };
        this.$store.dispatch('getControlDoctors', { args : args });
		},
        onAddReferent() {

        event.preventDefault();
        this.$v.$touch();

        if (!this.$v.$invalid ) {
            const args = {};
            let self = this;
            args.medecin_control_id = this.form.responsable.map(r => ({id: r.id}));
            args.patient_id = this.mMedicalFile.patient.user_id;

            const successMessage = this.$i18n.t('message.followedUpCreated');
            const errorMessages = {
                generic: this.$i18n.t('message.genericError'),
                error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
            };

            //let Larray = null;
            /*_.forEach(args.responsable,function(item){
                Larray =   _.find(self.mDoctors,function(m){
                    return m.id === item.id;
                });
                //this.referentDoctors.add(Larray);
            })*/
    
            const payload = { args, errorMessages, successMessage };
            this.$store.dispatch("addDoctorToPatient", payload).then(() => {
                this.getMedicalFile();
            }); 
        }
                
      },
    },
    mounted() {
        if(this.hasPatientRole){
            this.checkIfProfileComplete();
        }
        if (this.can) {
            this.getListOfMedicalAdvices();
        }

        // Fetch control doctor list
		this.getDoctors();

        new SlimSelect({
          select: '#responsable',
          placeholder: 'Select manager',
          // limit: 1
        });
    }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="">
    
</style>